import { IllustrationErrorTypes } from "../IllustrationTypes/index";
import SimpleError from "../../Illustrations/SimpleError";
import BadConnection from "../../Illustrations/BadConnection";
import PageNotFound from "../../Illustrations/PageNotFound";
import NoConnection from "../../Illustrations/NoConnection";
import FatalError from "../../Illustrations/FatalError";
import Error404 from "../../Illustrations/Error404";
import HeroLogout from "../../Illustrations/HeroLogout";
import ListIsEmpty from "../../Illustrations/ListIsEmpty";
export var getIllustrationFromType = function(ErrorType) {
    switch(ErrorType){
        case IllustrationErrorTypes.SIMPLE_ERROR:
            return SimpleError;
        case IllustrationErrorTypes.BAD_CONNECTION:
            return BadConnection;
        case IllustrationErrorTypes.PAGE_NOT_FOUND:
            return PageNotFound;
        case IllustrationErrorTypes.NO_CONNECTION:
            return NoConnection;
        case IllustrationErrorTypes.FATAL_ERROR:
            return FatalError;
        case IllustrationErrorTypes.ERROR_404:
            return Error404;
        case IllustrationErrorTypes.COME_BACK_LATER:
            return HeroLogout;
        case IllustrationErrorTypes.LIST_IS_EMPTY:
            return ListIsEmpty;
        default:
            return null;
    }
};
